module.exports = __webpack_public_path__ + "static/overview-f2017b2fd35b55e05299b02354b46a16.png";